import React from 'react';
import { Navbar } from '../components/Navbar';
import { StickyFooter } from '../components/StickyFooter';
type FAQItem = {
  question: string;
  answer: string;
};
const FAQ_ITEMS: FAQItem[] = [{
  question: 'How quickly can I get a worker placed?',
  answer: 'Our average match time is 4 minutes. For urgent shifts, we have workers available 24/7. Most facilities have their shift covered within 15 minutes of posting.'
}, {
  question: 'How are workers vetted?',
  answer: 'Every worker is screened by a registered nurse on our team. We verify CNO/CARNA/BCCNM registration, check references, conduct clinical competency assessments, and run criminal background checks.'
}, {
  question: 'What roles are available on Care Nomad?',
  answer: 'We currently offer PSWs (Personal Support Workers), RPNs (Registered Practical Nurses), RNs (Registered Nurses), LPNs (Licensed Practical Nurses), and HCAs (Health Care Aides).'
}, {
  question: 'Is Care Nomad available across Canada?',
  answer: "We currently serve Ontario, British Columbia, and Alberta. We're expanding to additional provinces in 2025. Enter your postal code to check availability in your area."
}, {
  question: 'How does billing work?',
  answer: "Billing is fully automated and transparent. You'll see the exact rate before confirming any shift. Invoices are generated automatically and payment is processed within 2 business days of shift completion."
}];
function FAQAccordion({
  items
}: {
  items: FAQItem[];
}) {
  return <>
      {items.map((item, index) => <details key={index} className="group bg-white border border-gray-200 rounded-xl overflow-hidden mb-4" data-id="element-946">
          <summary className="flex items-center justify-between px-6 py-4 cursor-pointer list-none hover:bg-soft-teal transition-colors" data-id="element-947">
            <span className="font-semibold text-text-dark text-sm pr-4" data-id="element-948">
              {item.question}
            </span>
            <span className="text-medical-blue text-xl font-light flex-shrink-0 group-open:rotate-45 transition-transform duration-200" data-id="element-949">
              +
            </span>
          </summary>
          <div className="px-6 pb-5 pt-1" data-id="element-950">
            <p className="text-text-muted text-sm leading-relaxed" data-id="element-951">
              {item.answer}
            </p>
          </div>
        </details>)}
    </>;
}
export function FAQ() {
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-952">
      <Navbar data-id="element-953" />
      <main className="flex-1" data-id="element-954">
        <section className="w-full bg-gray-50 py-16 lg:py-24 border-b border-gray-100" data-id="element-955">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-956">
            <h1 className="text-4xl sm:text-5xl font-extrabold text-text-dark tracking-tight mb-6" data-id="element-957">
              Frequently Asked Questions
            </h1>
            <p className="text-lg text-text-muted max-w-2xl mx-auto leading-relaxed" data-id="element-958">
              Everything you need to know about Care Nomad.
            </p>
          </div>
        </section>
        <div className="max-w-3xl mx-auto px-4 py-16" data-id="element-959">
          <FAQAccordion items={FAQ_ITEMS} data-id="element-960" />
        </div>
      </main>
      <StickyFooter data-id="element-961" />
    </div>;
}